// extracted by css-extract-rspack-plugin
export default {"answersStats":"AnswersStats-module__answersStats___qJFPM"};